import { AaGetcaptchaResp } from 'app/bff/models/aa/aaGetcaptcha';
import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { FormValues as AuthFormValues } from 'app/features/Member/Register/Auth/types';
import { Captcha, LoginInfo } from 'app/bff/models/mb/mbSignin';
import { AuthActions, MEMBER_REGISTER_AUTH__FETCH_CAPTCHA, MEMBER_REGISTER_AUTH__FETCH_CAPTCHA_DONE, MEMBER_AUTH__REGISTER_MEMBER, MEMBER_REGISTER_AUTH__FETCH_MEMBER_PROFILE_DONE, MEMBER_REGISTER_AUTH__SAVE_AUTH_PAGE_DATA, MEMBER_REGISTER_AUTH__RESET_CACHE } from './types';

/**
 * @description 取得圖形驗證碼 (Action)
 */
export const fetchCaptchaAction = (): AuthActions => ({
  type: MEMBER_REGISTER_AUTH__FETCH_CAPTCHA
});

/**
 * @description 取得圖形驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchCaptchaDoneAction = (response: AaGetcaptchaResp): AuthActions => ({
  type: MEMBER_REGISTER_AUTH__FETCH_CAPTCHA_DONE,
  payload: { response }
});

/**
 * @description 取得會員資料 (Action)
 * @param fetchMemberProfileArgs 取得會員資料，請求所需的參數
 * @param checkCaptchaArgs 驗證圖形驗證碼，請求所需的參數
 * @param data 頁面資料
 */
export const registerMemberAction = (checkCaptchaArgs: Captcha, data: LoginInfo): AuthActions => ({
  type: MEMBER_AUTH__REGISTER_MEMBER,
  payload: { checkCaptchaArgs, data }
});

/**
 * @description 取得會員資料 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchMemberProfileDoneAction = (response: MbGetinfoResp): AuthActions => ({
  type: MEMBER_REGISTER_AUTH__FETCH_MEMBER_PROFILE_DONE,
  payload: { response }
});

/**
 * @description 緩存「身分驗證」頁面資料 (Action)
 * @param data 頁面資料
 */
export const saveAuthPageDataAction = (data: AuthFormValues): AuthActions => ({
  type: MEMBER_REGISTER_AUTH__SAVE_AUTH_PAGE_DATA,
  payload: { data }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): AuthActions => ({
  type: MEMBER_REGISTER_AUTH__RESET_CACHE
});
